import { useTheme } from "@emotion/react";
import { Box, CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { GET_CITIES_BY_COUNTRY_ID, GET_COUNTRY_BY_ID, GET_FILTERED_CITIES, UPDATE_CITY_BY_ID } from "../../graphql/countriesQueries";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import i18n from "../../i18n/i18n";
import LoadingPage from "../../components/LoadingComponent";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DashboardFilterComponent from "../../components/Utilities/DashboardFilterComponent";
import TableComponent from "../../components/TableComponent/TableComponent";
import Header from "../../components/PageHeader/header";
import { useEffect } from "react";
import FilterComponent from "../../components/TableComponent/FilterComponent";
import { TrueOrFalseArr } from "../../constants";
import notify from "../../components/notify";
import ExportExcelAndPDF from "../../components/Utilities/ExportExcelAndPDF";
import logger from "../../utils/logger";

// GET_CITIES_BY_COUNTRY_ID
export default function AllCitiesInOneCountryPage() {

  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();
  const isArabic = i18n.language === "ar";

  logger.log("location", location.state);

  // get filtered cities
  const [
    FilteredPagedCities
    ,
    {
      data: {
        filteredPagedCities: {
          cities: getCitiesByCountry = [],
          total
        } = {}
      } = {},
      loading: citiesLoading,
      error: citiesError
    }
  ] = useLazyQuery(GET_FILTERED_CITIES,
    { fetchPolicy: "network-only" }
  );

  // get cities by country code
  // const [
  //   getAllCitiesInCountry,
  //   { data: citiesInCountry,
  //      loading: AllCitiesLoading,
  //      },
  // ] = useLazyQuery(GET_CITIES_BY_COUNTRY_ID, { fetchPolicy: "network-only" });

  const { data: {
    getCitiesByCountry: citiesInCountry
  }
  ={}, loading: AllCitiesLoading, error, refetch } = useQuery(
    GET_CITIES_BY_COUNTRY_ID,
    {
      variables: {
        country_id: id // الـ parameter هنا
      },
      fetchPolicy: "network-only",
      skip: !id // مش هتشغل ال query إلا لما يكون فيه countryId
    }
  );

  // logger.log("citiesInCountry",citiesInCountry);
 
  // get country
  const [
    Country
    ,
    {
      data: { country } = {},
      loading: countryLoading,
    }
  ] = useLazyQuery(GET_COUNTRY_BY_ID,
    { fetchPolicy: "network-only" }
  );

  const [
    UpdateCity,
    {
      loading: updatingStatus,
    }
  ] = useMutation(
    UPDATE_CITY_BY_ID,
    {
      fetchPolicy: "network-only"
    }
  );



  useEffect(() => {
    if (id) {
      let page;
      let limit;
      if (!searchParams.get("page")) {
        page = 1;
      }
      else {
        page = Number(searchParams.get("page"));
      }
      if (!searchParams.get("limit")) {
        limit = 10;
      }
      else {
        limit = Number(searchParams.get("limit"));
      }

      let searchText = "";

      if (searchParams.get("search")) {
        searchText = searchParams.get("search");
      }

      let variablesObj = {};
      if (page) variablesObj.page = page;
      if (limit) variablesObj.limit = limit;
      if (searchText) variablesObj.search = searchText;
      if (searchParams.get("status") && searchParams.get("status") !== "0") variablesObj.status = searchParams.get("status") === "true" ? true : false;

      variablesObj.country_id = id;
      // if(searchParams.get("role")) variablesObj.role=searchParams.get("role");

      FilteredPagedCities({ variables: variablesObj });


      Country({
        variables: {
          id: id
        }
      });

    }
  }, [searchParams]);


  let columns = [
    { key: "serial", label: t("Serial") },
    { key: "name_ar", label: t("Dashboard.NameInArabic") },
    { key: "name_en", label: t("Dashboard.NameInEnglish") },
    { key: "status", label: t("Status") },

  ];

  // logger.log("id",id);
  logger.log("data", getCitiesByCountry);

  logger.log("country", country);

  const fetchAndExport = async (type) => {
    try {

      const exportData = citiesInCountry?.map((user, i) => ({
        "#": i,
        [t("Dashboard.NameInArabic")]: user.name_ar,
        [t("Dashboard.NameInEnglish")]: user.name_en,
        // Mobile: user.mobile,
        // "User Type": user.userType,
        [t("Status")]: t(user.status),
      }));

      ExportExcelAndPDF({
        exportData,
        isArabic,
        reportTitle: isArabic ? `قائمة المدن (${country?.name_ar})` : `Cities List (${country?.name_en})`,
        type
      });

    } catch (err) {
      logger.error("Export error:", err);
    }
  };

  const addCityNavigate = () => navigate("add");

  const handleDetailsClick = (selectedRow) => {
    logger.log('handleDetailsClick', selectedRow);
    navigate(`details/${selectedRow?.id}`, {
      state: selectedRow
    });
  }

  const onFilterChange = async (filterOBJ) => {
    logger.log("filterOBJ", filterOBJ);
    if (filterOBJ.search) searchParams.set("search", filterOBJ.search);
    if (filterOBJ.hasOwnProperty("status") && filterOBJ.status !== "0") searchParams.set("status", filterOBJ.status);
    // searchParams.get("search", e.target.value);
    setSearchParams(searchParams);
  }

  const onStatusChange = async (selectedRow, newStatus) => {
    try {
      // logger.log("selectedRow", selectedRow, newStatus);
      // let row=getTransactionTypes?.find(el=>el?.id==selectedRow?.id);

      // // return;
      let data = {
        status: newStatus == "inActive" ? false : true,
        //   operation_type:row?.operation_type
      }
      const result = await UpdateCity({
        variables: {
          id: selectedRow?.id,
          input: data
        }
      });

      logger.log("reeesult", result);

      notify(t("success"), "success");

    } catch (error) {
      notify(t("error"), "error");
    }
  }

  let pageLimit;
  if (!searchParams.get("limit")) {
    pageLimit = 10;
  }
  else {
    pageLimit = Number(searchParams.get("limit"));
  }

  logger.log("pageLimit", pageLimit);

  const totalPages = parseInt(total / pageLimit) + 1;

  logger.log("totalPages", totalPages);


  const hasViewPermission = true;
  const hasAddPermission = true;
  if (!hasViewPermission) return <Navigate to="/profile" />;

  let translateText = isArabic ? "مدينة" : "City";
  let searchText = isArabic ? "بحث ب اسم المدينة" : "Search by city name";

  if (citiesLoading || countryLoading) return <LoadingPage />;
  return (
    <Box sx={{ p: 3, backgroundColor: "background.paper" }}>
      <Grid container spacing={3}>
        <Grid item
          sm={12} md={12}
          sx={{
            overflowX: "auto", // ✅ مهم جدًا عشان الجدول يعمل scroll داخل الـ Grid
          }}
        >
          {
            updatingStatus && <CircularProgress
              size={26}
              thickness={8}
              sx={{ color: "black" }}
            />
          }
          <Header
            title={t("cities")}
            subtitle={`${t("cities")} (${isArabic ? country?.name_ar : country?.name_en})`}
            i18n={i18n}
            haveBtn={hasAddPermission}
            btn={t("addItem", { item: translateText })}
            btnIcon={<ControlPointIcon sx={{ [isArabic ? "mr" : "ml"]: 1 }} />}
            onSubmit={addCityNavigate}
            isExcel
            isPdf
            isPrinter
            onExcel={() => fetchAndExport("excel")}
            onPdf={() => fetchAndExport("pdf")}
            onPrinter={() => fetchAndExport("print")}
          />

          <DashboardFilterComponent
            placeholder={searchText}
            textSearchField={"search"}
            statusKey={"status"}
            TrueOrFalseArr={TrueOrFalseArr}
            onFilterChange={onFilterChange}
            t={t}
          />


          <TableComponent
            columns={columns}
            data={getCitiesByCountry}
            // onViewDetails={(r) => navigate(`/userDetails/${r.id}`)}
            loading={citiesLoading}
            // isUsers={true}
            statusKey="status"
            sx={{
              flex: 1,
              overflow: "auto",
              boxShadow: 1,
              borderRadius: 1,
              width: "100%",
            }}
            handleDetailsClick={handleDetailsClick}
            onStatusChange={onStatusChange}
          />

          <FilterComponent totalPages={totalPages} />

        </Grid>
      </Grid>
    </Box>
  )
}
